import {
  createStoreSlice as createSlice,
  type PayloadAction,
} from '@/store/core';
import { RootState } from '@/store';
import { StoreError } from '@/types/storeError.interface';

interface ProviderState {
  loading: boolean;
  error: StoreError | null;
  providerInvitedAt: string | null;
}

const initialState: ProviderState = {
  loading: false,
  error: null,
  providerInvitedAt: null,
};

export const providerSlice = createSlice({
  name: 'provider',
  initialState,
  reducers: {
    providerLoading: state => {
      state.loading = true;
      state.error = null;
    },
    fetchProviderInviteStatusFailure: (
      state,
      action: PayloadAction<StoreError>,
    ) => {
      state.loading = false;
      state.error = action.payload;
      state.providerInvitedAt = null;
    },
    inviteProviderFailure: (state, action: PayloadAction<StoreError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProviderInviteStatusSuccess: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.loading = false;
      state.error = null;
      state.providerInvitedAt = action.payload;
    },
  },
});

export const {
  providerLoading,
  fetchProviderInviteStatusFailure,
  inviteProviderFailure,
  fetchProviderInviteStatusSuccess,
} = providerSlice.actions;

export const selectProvider = (state: RootState) =>
  state.provider as typeof initialState;

export default providerSlice.reducer;
